import * as eventsModel from './models/events';
import addTargetEventListener from '../events/addTargetEventListener';
import { selectors } from './elements/constants';
import getPanelById from './elements/getPanelById';
import getFormWizard from './elements/getFormWizard';
import * as actionModel from './models/action';

/**
 * Handles `formWizard.showStep` events called on go-to action steps.
 * @param {Event} event - The current event being handled
 */
function handleShowStep(event) {
  const action = actionModel.getAction(event.target);

  let toStep;
  if(actionModel.conditionsMet(action)) {
    toStep = getPanelById(getFormWizard(event.target), event.target.dataset.stepNameTo);
  } else {
    toStep = getPanelById(getFormWizard(event.target), event.target.dataset.stepNameElse);
  }

  const direction = event.detail.direction;
  eventsModel.dispatchNavigateEvent(event.target, { direction, toStep });
}

addTargetEventListener(eventsModel.events.showStep, selectors.actionGoTo, handleShowStep);
